import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { StickyCTA } from '../components/StickyCTA';
const TrustBar = lazy(() => import('../components/TrustBar').then(m => ({
  default: m.TrustBar
})));
const ContrastSection = lazy(() => import('../components/ContrastSection').then(m => ({
  default: m.ContrastSection
})));
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const ExpertSection = lazy(() => import('../components/ExpertSection').then(m => ({
  default: m.ExpertSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-235">
      <div data-id="element-236">
        <HeroSection data-id="element-237" />

        <Suspense fallback={null} data-id="element-238">
          <TrustBar data-id="element-239" />
          <ContrastSection data-id="element-240" />
          <ForWhomSection data-id="element-241" />
          <BenefitsSection data-id="element-242" />
          <ContentPreview data-id="element-243" />
          <BonusSection data-id="element-244" />
          <PricingSection data-id="element-245" />
        </Suspense>

        <Suspense fallback={null} data-id="element-246">
          <GuaranteeSection data-id="element-247" />
          <ExpertSection data-id="element-248" />
          <FAQSection data-id="element-249" />
          <Footer data-id="element-250" />
          <SocialProofPopup data-id="element-251" />
          <StickyCTA data-id="element-252" />
        </Suspense>
      </div>
    </main>;
}